import { Component, OnInit, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../common/shared.service';
import { Meta } from '@angular/platform-browser';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class to show 404 Error - /404
 **/
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit, AfterViewInit {

  loading: boolean;
  constructor(private meta: Meta, private translate: TranslateService, private sharedService: SharedService) {
    this.meta.addTag({ name: 'prerender-status-code', content: '404' });
  }

  ngOnInit() {
    this.loading = false;
  }

  ngAfterViewInit() {
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = this.translate.instant('pageTitle.home')+'404';
      this.sharedService.setTitleAndGtag(title);
    }); 
  }

}



// WEBPACK FOOTER //
// ./src/app/error/error.component.ts